import script from "./ChatWindowHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatWindowHeader.vue?vue&type=script&setup=true&lang=js"

import "./ChatWindowHeader.vue?vue&type=style&index=0&id=705c3d7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-705c3d7c"]])

export default __exports__